import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    addMatch(event) {
        event.preventDefault()

        const form = this.element.querySelector("form")
        if (!form) return

        const total = parseFloat(
            form.querySelector("[name='payment[total_amount]']")?.value || 0
        )

        const supplierName = this.getComboboxLabel("payment[supplier_id]")

        const item = {
            type: "Finance::Payment",
            id: `payment-${Date.now()}`,
            title: "Spend Money",
            subtitle: supplierName,
            amount: total,
            payload: this.serializeForm(form)
        }

        this.resetForm(form)

        this.dispatch("add", { detail: item })
    }

    getComboboxLabel(fieldName) {
        const hidden = this.element.querySelector(
            `input[type="hidden"][name="${fieldName}"]`
        )

        if (!hidden) return ""

        const fieldset = hidden.closest(".hw-combobox")
        if (!fieldset) return ""

        const selected = fieldset.querySelector(
            '[role="option"][aria-selected="true"]'
        )

        return selected?.textContent?.trim() || ""
    }

    serializeForm(form) {
        const payload = {
            account_id: form.querySelector("[name='payment[account_id]']")?.value,
            supplier_id: form.querySelector("[name='payment[supplier_id]']")?.value,
            payment_date: form.querySelector("[name='payment[payment_date]']")?.value,
            payment_method_id: form.querySelector("[name='payment[payment_method_id]']")?.value,
            reference: form.querySelector("[name='payment[reference]']")?.value || "",
            total_amount: parseFloat(
                form.querySelector("[name='payment[total_amount]']")?.value || 0
            ),
            payment_allocations_attributes: {}
        }

        const lines = form.querySelectorAll(".allocation-line")

        lines.forEach((line, index) => {
            const accountId = line.querySelector(
                "select[name*='[account_id]']"
            )?.value

            const amount = parseFloat(
                line.querySelector("input[name*='[amount]']")?.value || 0
            )

            const description =
                line.querySelector("input[name*='[description]']")?.value || ""

            if (accountId && amount > 0) {
                payload.payment_allocations_attributes[index] = {
                    account_id: accountId,
                    amount: amount,
                    description: description
                }
            }
        })

        return payload
    }

    resetForm(form) {
        form.reset()

        form.querySelector("[name='payment[supplier_id]']").value = null

        const container = form.querySelector(
            "[data-finance-payment-spend-target='container']"
        )

        if (container) container.innerHTML = ""

        const paymentController =
            this.application.getControllerForElementAndIdentifier(
                form,
                "finance-payment-spend"
            )

        if (paymentController) {
            paymentController.recalculate()
            paymentController.valid()
        }
    }
}
